module.exports = __webpack_public_path__ + "static/media/google-cloud-search.1b1bb233.svg";